import { render } from "./UserModulesDialog.vue?vue&type=template&id=17bf1654&scoped=true"
import script from "./UserModulesDialog.vue?vue&type=script&lang=js"
export * from "./UserModulesDialog.vue?vue&type=script&lang=js"

import "./UserModulesDialog.vue?vue&type=style&index=0&id=17bf1654&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bf1654"]])

export default __exports__